import api from "../Utils/axios";
import { filterParams } from "../Utils/helpers";

export const getAllRides = (
    page,
    perPage,
    search_string,
    status,
    from,
    to,
    user,
    driver
) => {
    return api.get(`/ride/get`, {
        params: filterParams({
            page,
            limit: perPage,
            keyword: search_string,
            status,
            "createdAt[from]": from,
            "createdAt[to]": to,
            user,
            driver,
        }),
    });
};

export const getAllBusinessMuvvrRides = (
    page,
    perPage,
    search_string,
    status,
    from,
    to,
    user,
    // driver,
    id
) => {
    return api.get(`/ride/getBusinessMuvvrRides`, {
        params: filterParams({
            page,
            limit: perPage,
            keyword: search_string,
            status,
            "createdAt[from]": from,
            "createdAt[to]": to,
            user,
            // driver,
            driver_id: id
        }),
    });
};

export const getRideDetails = (id) => {
    return api.get(`/ride/get`, {
        params: {
            _id: id,
        },
    });
};

/** Cancels any non-final ride as admin; releases the customer's payment hold. */
export const adminCancelRide = (id, reason) => {
    return api.post(`/ride/admin/cancel/${id}`, { reason });
};

/** Removes the assigned mover (accepted/arrived only) and restarts the mover search. */
export const adminReassignRide = (id, reason) => {
    return api.post(`/ride/admin/reassign/${id}`, { reason });
};

/** Short-lived PDF link: type "customer" = customer invoice, "driver" = mover earnings statement. */
export const getInvoiceLink = (requestId, type) => {
    return api.get(`/ride/invoice/link`, { params: { requestId, type } });
};

export const getPaymentRecords = (page, perPage, search_string, from, to) => {
    return api.post(`/ride/admin/payment-records`, filterParams({
        page,
        limit: perPage,
        search: search_string,
        from,
        to,
    }));
};
